import React from "react";
import { useFiconPhoneNumber } from "./hooks/useFiconPhoneNumber";
import styles from "./style/FiconPhoneNumber.module.scss";

const FiconPhoneNumber = ({ phoneNumber = "", sizeIcon = "15px" }) => {
  phoneNumber = "+" + phoneNumber.replace("-", "").replace("+", "");
  const _lada = phoneNumber.substring(0, phoneNumber.length - 10);
  const _phoneNumber = phoneNumber.substr(-10);
  return (
    <>
      <div>
        <img
          className="float-left border-0 h-full mr-2 rounded-sm"
          src={
            _lada == "+1"
              ? require("../../components/assets/images/usa.png")
              : _lada == "+57"
              ? require("../../components/assets/images/colombia.png")
              : _lada == "+52"
              ? require("../../components/assets/images/MX.png")
              : null
          }
          style={{ height: sizeIcon }}
        />
        <div className="float-left border-0">
          {"(" +
            _phoneNumber.substring(0, 3) +
            ") " +
            _phoneNumber.substring(3, 6) +
            " " +
            _phoneNumber.substring(6, 10)}
        </div>
      </div>
    </>
  );
};

export default FiconPhoneNumber;
